module.exports = __webpack_public_path__ + "img/67.9346057e.webp";